import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import * as _ from 'lodash';
import * as moment from 'moment';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import Chart from 'chart.js';
import Slider from 'material-ui/Slider';

export default function SuspiciousSessionsPage() {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [minSessions, setMinSessions] = useState(4);
    const [selectedAcc, setSelected] = useState();
    const [selectedAccInfo, setAdditionalInfo] = useState();

    function loadUsers(nextPage, minSessions) {
        if (items.length == 0 && nextPage > page) {
            return;
        }
        nextPage = Math.max(1, nextPage);

        axios.get('/api/v2/stats/concurrent-sessions', {
            params: {
                page: nextPage,
                minSessions,
            },
        }).then((resp) => {
            setItems(resp.data.data);
            setPage(nextPage);
        });
    }

    function loadSpecificUser(userId) {
        Promise.all([
            axios.get('/api/v2/stats/concurrent-sessions', { params: { userId } }).then(resp => resp.data.data[0]),
            axios.get('/socket.io/api/activeSessions', { params: { userId } }).then(resp => resp.data).catch(() => null),
        ]).then(([info, sockets]) => {
            const items = _.orderBy(info.perHour, i => i.hour);

            info.perHour = [];
            const format = 'YYYY-MM-DD HH';
            if (items.length > 0) {
                for (let date = moment.utc(items[0].hour, format); date.isBefore(moment()); date.add(1, 'hour')) {
                    const cTime = date.format(format);
                    const item = items.find(i => i.hour == cTime);
                    if (item) {
                        info.perHour.push(item);
                        items.shift();
                    } else {
                        info.perHour.push({ hour: cTime, sessions: [] });
                    }
                }
            }

            info.currentStatus = sockets;

            setAdditionalInfo(info);
        });
    }

    async function onSelect(indexes) {
        if (indexes.length == 0) {
            setSelected(undefined);
            setAdditionalInfo(undefined);
            return;
        }
        const item = items[indexes];
        setSelected(item);
        setAdditionalInfo(undefined);
        loadSpecificUser(item._id);
    }

    function onMinSessionsChanged(e, val) {
        setMinSessions(val);
        setPage(1);
    }

    useEffect(() => {
        loadUsers(page, minSessions);
    }, [minSessions]);

    return (
        <div>
            <h3>
                <p className='text-center'>Suspicious user sessions</p>
            </h3>
            <div style={{ height: '30px', display: 'flex', alignItems: 'center' }}>
                <div style={{
                    display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '200px', height: '100%', 
                }}
                >
                    <button onClick={() => loadUsers(page - 1, minSessions)}>Prev</button>
                    <span>{ page }</span>
                    <button onClick={() => loadUsers(page + 1, minSessions)}>Next</button>
                </div>

                <div>
                    <span>Min sessions: {minSessions}</span>
                    <Slider
                        value={minSessions}
                        onChange={onMinSessionsChanged}
                        min={1}
                        max={10}
                        step={1}
                        style={{ width: 200, height: '100%' }}
                        axis='x'
                        sliderStyle={{ margin: 0 }}
                    />
                </div>
            </div>

            <div className='row'>
                <div className='col-md-5'>
                    <SuspiciousUserTable items={items} selected={selectedAcc} onSelection={onSelect} />
                </div>
                <div className='col-md-7'>
                    {
                        selectedAcc && <Details account={selectedAcc} info={selectedAccInfo} />
                    }
                </div>
            </div>
        </div>
    );
}

function SuspiciousUserTable({ items, selected, onSelection }) {
    return (
        <Table
            fixedHeader
            selectable
            onRowSelection={onSelection}
        >
            <TableHeader
                adjustForCheckbox
            >
                <TableRow>
                    <TableHeaderColumn tooltip='Name'>Name</TableHeaderColumn>
                    <TableHeaderColumn tooltip='Email'>Email</TableHeaderColumn>
                    <TableHeaderColumn tooltip='Company'>Company</TableHeaderColumn>
                    <TableHeaderColumn tooltip='Sessions'>Sessions</TableHeaderColumn>
                    <TableHeaderColumn />
                </TableRow>
            </TableHeader>
            <TableBody
                displayRowCheckbox
                deselectOnClickaway={false}
            >
                {items.map(item => (
                    <TableRow key={item._id} selected={item == selected}>
                        <TableRowColumn>{value(item.user.name)}</TableRowColumn>
                        <TableRowColumn>{value(item.user.email)}</TableRowColumn>
                        <TableRowColumn>{value(item.user.company && item.user.company.name)}</TableRowColumn>
                        <TableRowColumn>{value(item.maxSessions)}</TableRowColumn>
                        <TableRowColumn>
                            <RaisedButton
                                label='Details'
                                href={`/users/${item.user._id}?panel=SessionLimits`}
                                target='_blank'
                                primary
                            />
                        </TableRowColumn>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

function value(val) {
    return <span title={val}>{val}</span>;
}

function Details({ account, info }) {
    console.log(info);
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: '1.5em' }}>
                <div style={{
                    flex: '1', display: 'flex', flexDirection: 'column', lineHeight: '2', 
                }}
                >
                    <span><b>Name:</b> { account.user.name }</span>
                    <span><b>Company:</b> { account.user.company && account.user.company.name }</span>
                    <span><b>Email:</b> { account.user.email }</span>
                </div>
                <div style={{
                    flex: '1', display: 'flex', flexDirection: 'column', lineHeight: '2', 
                }}
                >
                    {
                        info && info.currentStatus && 
                        <React.Fragment>
                            <span><b>Connections:</b> { info.currentStatus.connectionCount }</span>
                            <span><b>Sessions:</b> { info.currentStatus.sessions.join(', ') }</span>
                        </React.Fragment>
                    }
                </div>
            </div>
            {
                info &&                 
                <div>
                    <BaseChart items={info.perHour.map(h => [h.hour, h.sessions.length])} />
                </div>
            }
        </div>
    );
}


function BaseChart({ items }) {
    const chartRef = useRef();
    const chart = useRef(null);

    useEffect(() => {
        chart.current = createChart([], []);
    }, []);

    useEffect(() => {
        const [labels, datasets] = drawChart(items);
        updateChart(chart.current, labels, datasets);
    }, [items]);

    function drawChart(items) {
        const labels = [];
        const points = [];

        for (const item of items) {
            labels.push(item[0]);
            points.push(item[1]);
        }

        const datasets = [
            {
                label: 'Unique sessions',
                backgroundColor: 'rgba(135, 197, 239, 0.5)',
                borderColor: 'rgb(54, 162, 235)',
                data: points,
            },
        ];

        return [labels, datasets];
    }

    function updateChart(chart, labels, datasets) {
        chart.clear();
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update();

        return chart;
    }

    function createChart(labels, datasets) {
        const ctx = chartRef.current.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    xAxes: [{
                        stacked: true,

                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            min: 0,
                        },
                    }],
                },
            },
        });

        return chart;
    }

    return (
        <canvas ref={chartRef} />
    );
}



// WEBPACK FOOTER //
// ./app/components/Users/SuspiciousSessions/Page.jsx